import { ConsentType } from '@/enums'
import { Language, RequiredConsent } from '@/types'
import { fetchUserRequiredConsents } from '@/api'

export const consentLabelByType: Record<ConsentType, string> = {
  [ConsentType.ClientDataProcessing]: 'MetabolicLang.addClient.acceptConsent',
  [ConsentType.ClientUseOfPseudonymizedData]: 'MetabolicLang.addClient.acceptData',
  [ConsentType.ClientMarketing]: 'MetabolicLang.addClient.acceptMarketing',
  [ConsentType.JCA]: 'JCA',
  [ConsentType.DPA]: 'DPA',
  [ConsentType.ClientDataUseInApp]: 'MetabolicLang.Legal.ConsentDataUseAppLabel',
}

export const coachesClientConsentLabelByType: Record<ConsentType, string> = {
  [ConsentType.ClientDataProcessing]: 'MetabolicLang.addClient.acceptConsent',
  [ConsentType.ClientUseOfPseudonymizedData]: 'MetabolicLang.addClient.acceptData',
  [ConsentType.ClientMarketing]: 'MetabolicLang.addClient.acceptMarketing',
  [ConsentType.JCA]: 'JCA',
  [ConsentType.DPA]: 'DPA',
  [ConsentType.ClientDataUseInApp]: 'MetabolicLang.Legal.ConsentDataUseAppLabel',
}

export const clientConsentLabelByType: Record<ConsentType, string> = {
  [ConsentType.ClientDataProcessing]: 'MetabolicLang.patients.acceptConsent',
  [ConsentType.ClientUseOfPseudonymizedData]: 'MetabolicLang.patients.acceptData',
  [ConsentType.ClientMarketing]: 'MetabolicLang.patients.acceptMarketing',
  [ConsentType.JCA]: 'JCA',
  [ConsentType.DPA]: 'DPA',
  [ConsentType.ClientDataUseInApp]: 'MetabolicLang.Legal.ConsentDataUseAppLabel',
}

export const loadRequiredConsentsByLanguage = async (language: Language): Promise<RequiredConsent[]> => {
  try {
    return fetchUserRequiredConsents(language)
  } catch (error: any) {
    console.log(error)
    throw error
  }
}
